export const downloadsAccordionFn = () => {
  const boxes = document.querySelectorAll(".downloads-box");
  if (!boxes.length) return;

  boxes.forEach((box) => {
    const accordions = box.querySelectorAll(".downloads-accordion");

    accordions.forEach((accordion) => {
      const header = accordion.querySelector(".downloads-accordion__header");
      const content = accordion.querySelector(".downloads-accordion__content");

      if (!header || !content) return;

      // init
      content.style.height = "0px";
      content.style.overflow = "hidden";

      header.addEventListener("click", () => {
        const isOpen = accordion.classList.contains("opened");

        // zamykamy inne w tym boxie
        accordions.forEach((acc) => {
          if (acc !== accordion) {
            acc.classList.remove("opened");
            const c = acc.querySelector(".downloads-accordion__content");
            if (c) c.style.height = "0px";
          }
        });

        if (!isOpen) {
          accordion.classList.add("opened");
          const h = content.scrollHeight;
          content.style.height = h + "px";
        } else {
          content.style.height = "0px";
          accordion.classList.remove("opened");
        }
      });
    });
  });
};
